import { useState } from "react";

export const TrendTrackerControl = ({ currentTrendTracker, loading, onSetTrendTracker }) => {
    const [trendTracker, setTrendTracker] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        await onSetTrendTracker(trendTracker);
        setTrendTracker('');
    };

    return (
        <div className="bg-slate-800 p-3 rounded-lg border border-slate-700">
            <h2 className="text-sm font-semibold text-white mb-2">
                Trend Tracker
            </h2>

            <form onSubmit={handleSubmit}>
                <div className="mb-1.5">
                    <label className="block text-xs font-medium text-slate-300 mb-1">
                        Directions Count
                    </label>
                    <input 
                        type="number"
                        min="1"
                        step="1"
                        placeholder="Enter directions" 
                        value={trendTracker} 
                        onChange={(e) => setTrendTracker(e.target.value)}
                        required
                        className="w-full h-8 px-2 text-xs bg-slate-900 text-white border border-slate-700 rounded outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                    />
                </div>
                
                <button 
                    type="submit"
                    disabled={loading}
                    className={`w-full py-1.5 text-xs font-medium text-white rounded transition-all ${
                        loading 
                            ? 'bg-gray-400 cursor-not-allowed' 
                            : 'bg-blue-500 hover:bg-blue-600 cursor-pointer'
                    }`}
                >
                    {loading ? 'Setting...' : 'Set Tracker'}
                </button>
            </form>

            {currentTrendTracker !== null && (
                <div className="mt-2 pt-2 border-t border-slate-700">
                    <div className="flex items-center justify-between text-xs">
                        <span className="text-slate-400">Current:</span>
                        <span className="font-semibold text-blue-400">
                            {currentTrendTracker}
                        </span>
                    </div>
                </div>
            )}
        </div>
    );
};
